import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import './changePasswordPopup.scss';
import Icon, { IconType, IconSize } from '../../atoms/icon/icon';
import InputText from '../../atoms/inputText/inputText';
import ModalBootstrap from 'react-bootstrap/Modal';
import { Container, Row, Form } from 'react-bootstrap';
import { changePassword } from '../../../store/externalCalls/api/sessionApi';
import swal from 'sweetalert';
import { loadState } from '../../../store/sessionStore';

export const ModalSize = {
  LARGE: 'lg',
  SMALL: 'sm',
  '': '',
};
/**
 * Help button is a Button associate to popup paragraph with a help text.
 */
 let userEmail;

const ChangePasswordPopup = (props) => {
  const {
    id,
    onChange,
    value,
    type,
    show,
    email,
  } = props;

  const [payload, setPayload] = useState('')
  const [newPassword, setNewPassword] = useState('')
  const [newPasswordConfirmation, setNewPasswordConfirmation] = useState('')
  function handleSubmit(e) {
    e.preventDefault();
    userEmail = email ||  loadState().sessionEmail;
    changePassword({...payload, email: userEmail}).then(() => {  
      swal('Success', 'Password has been updated successfully', 'success');
      onChange(false)
    }, (error) => {
      const message = error.errors ? error.errors.new_password[0] : error.message;
      swal('Error', message, 'error');
    });
  }
  const handleClose = (e) => {
    onChange(false)
  };
  const handleChange = (value, target) => {
    setPayload({ ...payload , [target]:value.currentTarget.value})
  };
  return (
    <div className="d-inline position-relative">
      <ModalBootstrap size={'sm'}
        show={show}
        onHide={handleClose}
        >
      <ModalBootstrap.Header closeButton>
        <ModalBootstrap.Title>Change Password</ModalBootstrap.Title>
      </ModalBootstrap.Header>
      <ModalBootstrap.Body>
      <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formOldPassword">
            <Form.Label>Old Password</Form.Label>
            <Form.Control type="password" 
            placeholder="Password" 
            required={true}
            onChange={(e)=>{handleChange(e, 'password')}}/>
          </Form.Group>
          <Form.Group controlId="formNewPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control minLength={8} type="password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&]).{8,}"  title="Must contain at least one  number, one uppercase and lowercase letter, one special character and at least 8 or more characters" placeholder="Password" required={true} onChange={(e)=>{handleChange(e, 'new_password')}}/>
          </Form.Group>

          <Form.Group controlId="formConfirmPassword">
            <Form.Label>Repeat new password</Form.Label>
            <Form.Control minLength={8} pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*#?&]).{8,}" title="Must contain at least one  number, one uppercase and lowercase letter, one special character and at least 8 or more characters" type="password" placeholder="Password" required={true} onChange={(e)=>{handleChange(e, 'new_password_confirmation')}}/>
          </Form.Group>
          <Button variant="primary" type="submit" className="btn btn-primary">
            Submit
          </Button>
        </Form>
      </ModalBootstrap.Body>
      <ModalBootstrap.Footer>
      <div style={{width:'100%'}}>The password must include:</div>
      <div className={`rule popup__rules`} style={{fontSize:'0.75rem'}}>
      <div>- The length of the password must be at least 8 characters</div>
        <div>- An upper and lower case character</div>
        <div>- A number</div>
        <div>- A special character, e.g @$!%*#?& </div>
      </div>
      </ModalBootstrap.Footer>
    </ModalBootstrap>
      
    </div>
  );
};

ChangePasswordPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.bool,
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  type: PropTypes.node,
};

ChangePasswordPopup.defaultProps = {
  onChange: () => {},
  value: '',
  id: -1,
  type: null,
};

export default ChangePasswordPopup;
